import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import ACNavigatorButton from 'academy-common-lib/components/navigation/contentNavigator/ACNavigatorButton';
import ExamTimer from '../../features/exams/components/ExamTimer';
import TrackViewAwardLink from '../TrackCard/TrackViewAwardLink';
import { getHumanizedDuration } from '../../utils/utils.migrated';
import { getExamIsRecent, getMostRecentExamAttempt, isExpired } from '../../features/exams/examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NavigatorExamButton = ({
  active,
  award,
  track,
  trackProgress
}) => {
  const {
    exam,
    id: trackId
  } = track;
  const mostRecentExamAttempt = trackProgress && exam ? getMostRecentExamAttempt(exam.id, trackProgress) : null;
  const attemptFinished = (mostRecentExamAttempt === null || mostRecentExamAttempt === void 0 ? void 0 : mostRecentExamAttempt.attemptFinishTime) != null;
  const examIsRecent = getExamIsRecent(mostRecentExamAttempt);
  const correctQuestionCount = mostRecentExamAttempt === null || mostRecentExamAttempt === void 0 ? void 0 : mostRecentExamAttempt.score;
  const certificationExpired = !examIsRecent && isExpired(award === null || award === void 0 ? void 0 : award.expiresAt);
  return /*#__PURE__*/_jsx(ACNavigatorButton, {
    active: active,
    "data-test-id": "navigator-exam-button",
    helpText: mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed && !certificationExpired ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.score",
        options: {
          correctQuestionCount,
          totalQuestionCount: (exam === null || exam === void 0 ? void 0 : exam.length) || 0
        }
      }), /*#__PURE__*/_jsx(TrackViewAwardLink, {
        award: award || undefined,
        certification: true,
        trackId: trackId,
        useButton: false
      })]
    }) : !(mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed) && attemptFinished ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.score",
        options: {
          correctQuestionCount,
          totalQuestionCount: (exam === null || exam === void 0 ? void 0 : exam.length) || 0
        }
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.failed"
      })]
    }) : mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed && certificationExpired ? /*#__PURE__*/_jsxs(List, {
      use: "inline-divided",
      wrapChildren: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.expired"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.finished.failed"
      })]
    }) : mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.passed ? /*#__PURE__*/_jsx(ExamTimer, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      passive: true,
      track: track
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.navigation.duration",
      options: {
        duration: getHumanizedDuration((exam === null || exam === void 0 ? void 0 : exam.durationMinutes) || 0, 'minutes')
      }
    }),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.exams.exam"
    }),
    to: `/tracks/${trackId}/exam`
  });
};
export default NavigatorExamButton;